module.exports = __webpack_public_path__ + "img/gaming.ea369563.png";